import { render, staticRenderFns } from "./promote-detail.vue?vue&type=template&id=74a5cef3&scoped=true"
import script from "./promote-detail.vue?vue&type=script&lang=ts"
export * from "./promote-detail.vue?vue&type=script&lang=ts"
import style0 from "./promote-detail.vue?vue&type=style&index=0&id=74a5cef3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a5cef3",
  null
  
)

export default component.exports